import Category from '@/models/Category';

export default class AssetCategory extends Category {
    static get enumKey () {
        return 'asset-categories';
    }

    static get storageKey () {
        return 'assetCategories';
    }

    static get commitSet () {
        return 'GET_ASSETCATEGORIES';
    }

    static get commitUpdate () {
        return 'UPDATE_ASSET_CATEGORY';
    }

    static get commitRemove () {
        return 'REMOVE_ASSET_CATEGORY';
    }

    static get className () {
        return 'AssetCategory';
    }
}
